import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function H() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solar_panel_175w');
    const { locale } = useRouter();
    // eu 6 站去掉最后 DPU css 隐藏
    const data = [
        [t('H_row1_col1'), t('H_row1_col2'), t('H_row1_col3'), t('H_row1_col4'), t('H_row1_col5'), t('H_row1_col6'), t('H_row1_col7'), t('H_row1_col8')],
        [t('H_row2_col1'), t('H_row2_col2'), t('H_row2_col3'), t('H_row2_col4'), t('H_row2_col5'), t('H_row2_col6'), t('H_row2_col7'), t('H_row2_col8')],
        [
            t('H_row3_col1'),
            t('H_row3_col2'),
            t('H_row3_col3'),
            t('H_row3_col4'),
            [{ text: t('H_row3_col5_text'), memo: t('H_row3_col5_memo') }],
            [{ text: t('H_row3_col6_text'), memo: t('H_row3_col6_memo') }],
            [{ text: t('H_row3_col7_text'), memo: t('H_row3_col7_memo') }],
            [
                { text: t('H_row3_col8_text1'), memo: t('H_row3_col8_memo1') },
                { text: t('H_row3_col8_text2'), memo: t('H_row3_col8_memo2') },
            ],
        ],
        [
            t('H_row4_col1'),
            t('H_row4_col2'),
            t('H_row4_col3'),
            t('H_row4_col4'),
            [{ text: t('H_row4_col5_text'), memo: t('H_row4_col5_memo') }],
            [{ text: t('H_row4_col6_text'), memo: t('H_row4_col6_memo') }],
            [{ text: t('H_row4_col7_text'), memo: t('H_row4_col7_memo') }],
            [{ text: t('H_row4_col8_text'), memo: t('H_row4_col8_memo') }],
        ],
    ];

    const IMGS = [
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125299696/8_1.png',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125308450/8_2.png',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125389039/8_3.png',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125395873/8_4.png',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125405883/8_5.png',
        // 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125412484/8_6.png',
        'https://websiteoss.ecoflow.com/website/upload/2022/3/7/DELTA%20PRO%20related_1646639685749.png',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717125419207/8_7.png',
    ];

    return (
        <div className={`sp-175w-H sp-175w-common ${css['sp-175w-H']}`}>
            <div className="info">
                <p className="title">{t('H_title')}</p>
            </div>
            <div className="wrapper">
                <table className="table">
                    <tbody className="tbody">
                        {data?.map((tr: any, k: number) => (
                            <tr className="tr" key={k}>
                                {tr?.map((td: any, m: number) => (
                                    <td className="td" key={`${k}_${m}`}>
                                        {k === 0 && m !== 0 && (
                                            <div className="cell-img">
                                                <EFPicture src={IMGS[m - 1]} alt={td} />
                                            </div>
                                        )}
                                        {Array.isArray(td) ? (
                                            <ul className="cell-ul">
                                                {td.map((list: any, n: number) => (
                                                    <li className="cell-li" key={`${k}_${m}_${n}`}>
                                                        {list?.text && <p className="cell-text">{list.text}</p>}
                                                        {list?.memo && <p className="cell-memo">{list.memo}</p>}
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="cell-text">{td}</p>
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <p className="tip">{t('H_tip')}</p>
        </div>
    );
}
